import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";

import { logout, changePassword } from "../../actions/auth";
import { FERADEL_LOGO_PATH } from "../../constants/brand";
import Notifications from "../notifications";
import PasswordBar from "../../layout/password";
import { deepEqual } from "../../utils/object";

export class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        fullscreen: false,
        password: false,
      },
      password: {
        original: "",
        new: "",
        confirmed: "",
        score: 0
      },
      avatar: "https://www.gravatar.com/avatar/HASH?d=mp&s=24",
      email: "",
    };
  }

  componentDidMount = () => {
    this.setState({
      ...this.state,
      avatar: this.props?.user?.avatar,
      email: this.props?.user?.email,
    });
  };

  componentDidUpdate = (oldProps) => {
    if (!deepEqual(oldProps.user, this.props.user)) {
      this.setState({
        ...this.state,
        avatar: this.props.user?.avatar,
        email: this.props.user?.email,
      });
    }
  };

  setNewPassword = (e) => {
    this.setState({
      ...this.state,
      password: { ...this.state.password, new: e },
    });
  };

  setConfirmedPassword = (e) => {
    this.setState({
      ...this.state,
      password: { ...this.state.password, confirmed: e },
    });
  };

  onPasswordScored = (score, feedback) => {
    this.setState(prev => ({
      ...prev,
      password: {
        ...prev.password,
        score
      }
    }));
  };

  hideChangePassword = () => {
    this.setState({
      ...this.state,
      display: {
        ...this.state.display,
        password: false,
      },
      password: {
        original: "",
        new: "",
        confirmed: "",
        score: 0,
      },
    });
  };

  onClickSavePassword = async () => {
    const { original, new: newPassword, confirmed, score } = this.state.password;

    if (!original || !newPassword || !confirmed) {
      return;
    }

    if (newPassword !== confirmed) {
      return;
    }

    if (score < 4) {
      return;
    }

    const result = await this.props.changePassword(this.props.user.uuid, this.state.password);
    if (result?.success !== false) {
        this.hideChangePassword();
    }
  };

  isInFullScreenFn = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  toggleFullScreen = () => {
    const isFS = this.isInFullScreenFn();

    const docElm = document.documentElement;
    if (!isFS) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    this.setState({
      ...this.state,
      display: {
        fullscreen: !isFS,
        change: false,
      },
    });
  };

  render() {
    const { original, new: newPassword, confirmed, score } = this.state.password;

    const passwordsMatch = !!newPassword && !!confirmed && newPassword === confirmed;
    const hasMismatch = !!confirmed && newPassword !== confirmed;
    const meetsCompliance = score >= 4;

    const canSave =
      !!original &&
      !!newPassword &&
      !!confirmed &&
      passwordsMatch &&
      meetsCompliance;

    return (
      <nav id="nav" className="licensee-topbar nav-container d-flex">
        <div className="nav-content d-flex">
          <div
            className="licensee-logo logo position-relative"
          >
            <Link
              to="/dashboard"
              aria-label="Feradel Dashboard"
              className="d-flex align-items-center h-100"
            >
              <img
                src={FERADEL_LOGO_PATH}
                alt="Feradel"
                className="licensee-logo-image"
              />
            </Link>
          </div>

          <div className="user-container d-flex">
            <Dropdown className="dropdown-menu-right">
              <Dropdown.Toggle
                color="empty"
                className="licensee-user-toggle d-flex user position-relative"
              >
                <img className="profile" alt="Profile" src={this.state.avatar} />
                <div className="name">{this.state.email}</div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="mt-3" end>
                <Dropdown.Item
                  onClick={(e) =>
                    this.setState({
                      ...this.state,
                      display: {
                        ...this.state.display,
                        password: true,
                      },
                    })
                  }
                >
                  Change password
                </Dropdown.Item>
                <Dropdown.Item onClick={this.props.logout}>Sign out</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="menu-container flex-grow-1"></div>
          
          <Notifications />          

          <Modal show={this.state.display.password} onHide={this.hideChangePassword}>
            <ModalHeader>Change Password</ModalHeader>
            <ModalBody>
              <div className="form-group col-md-12">
                <label className="text-muted text-small">Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="originalPassword"
                  name="originalPassword"
                  value={original}
                  onChange={(e) =>
                    this.setState({
                      ...this.state,
                      password: {
                        ...this.state.password,
                        original: e.target.value,
                      },
                    })
                  }
                />
              </div>

              <div className="form-group col-md-12">
                <label className="text-muted text-small">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => this.setNewPassword(e.target.value)}
                />

                <div className="mt-2">
                  <PasswordBar password={newPassword} minLength={8} score={score} upper={1} lower={1} symbol={1} number={1} onChangeScore={this.onPasswordScored} />
                </div>
              </div>

              <div className="form-group col-md-12">
                <label className="text-muted text-small">Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmedPassword"
                  name="confirmedPassword"
                  value={confirmed}
                  onChange={(e) => this.setConfirmedPassword(e.target.value)}
                />

                {hasMismatch && (
                  <small className="text-danger d-block mt-2">
                    Passwords do not match.
                  </small>
                )}
              </div>
            </ModalBody>

            <ModalFooter>
              <Button variant="primary" onClick={this.onClickSavePassword} disabled={!canSave}>
                Save
              </Button>
              <Button variant="secondary" onClick={this.hideChangePassword}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
        
        <div className="nav-shadow"></div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.auth.user,
});

export default connect(mapStateToProps, { logout, changePassword })(Navbar);
